export default __webpack_public_path__ + "static/media/Pix.8ed5df26.svg";